import { PostOfficeWeekInterface } from '../api/schedulerReferenceApi';

export const isTimeCorrect = (value:string):boolean => {
  if (value.length < 5) { return true; } // проверяем только полностью введённое время
  try {
    const h = +value.split(':')[0];
    const m = +value.split(':')[1];
    if (h < 0) return false;
    if (h > 23) return false;
    if (m < 0) return false;
    if (m > 59) return false;
  } catch {
    return false;
  }
  return true;
};

// переводит время в минуты для валидации (пример: 10:00 в 600 минут)
export const getTimeInMinutes = (value:string):number => {
  if (value.length < 5) { return 0; } // проверяем только полностью введённое время
  try {
    const h = +value.split(':')[0];
    const m = +value.split(':')[1];
    return h * 60 + m + 60;
  } catch {
    return 0;
  }
};

// спец.функция для валидации - проверяем, что время оканчивается на 00 или 30.
export const isMinutesValid = (value:string):boolean => {
  if (value.length < 5) { return false; } // проверяем только полностью введённое время
  try {
    const m = +value.split(':')[1];
    if ((m === 0) || (m === 30)) return true;
    return false;
  } catch {
    return false;
  }
};

// следующая функция проверяет недельное расписание - есть ли там некорректные значения
// и можно ли записать расписание
// Если функцию вернула true - то всё верно, есть изменения, включаем кнопку "Сохранить"
export const canSavePostOfficeWeek = (postOfficeWeek:PostOfficeWeekInterface):boolean => {
  if (postOfficeWeek && postOfficeWeek?.days.length > 0) {
    if (postOfficeWeek?.days.find(
      (v) => v.times.find((k) => ((k?.beginTimeIsError || k?.endTimeIsError) && (!k?.deleted)))
    )) { return false; }
    if (postOfficeWeek?.days.find(
      (v) => v.times.find((k) => (getTimeInMinutes(k?.beginTime) >= getTimeInMinutes(k?.endTime === '00:00' ? '24:00' : k?.endTime) && (!k?.deleted)))
    )) { return false; }
    if (!postOfficeWeek?.days.find(
      (v) => v.times.find((k) => (
        ((k?.created) && (!k?.deleted))
        || ((k?.updated) && (!k?.deleted))
        || ((!k?.created) && (k?.deleted))
      ))
    )) { return false; }
  }
  return true;
};
